import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { RoleListActionsCell } from './role-list-actions.cell';
import { RoleListActionsHeader } from './role-list-actions.header';

export const RoleListActionsColumn: DisplayColumnDef<
  GatewayRoleModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: RoleListActionsHeader,
  cell: RoleListActionsCell,
};
